import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
    tplaylists : localStorage.getItem('tplaylists') && JSON.parse(localStorage.getItem('tplaylists'))  || [],
    filterResults: ''
};

const module = {
    state,
    getters,
    mutations,
    actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/trendingPlaylists/index.js